<template>
  <v-dialog v-model="scheduleDialog" width="800">
    <template v-slot:activator="{ on }">
      <v-btn class="mb-2" v-if="editingDate != null" x-small text color="primary" v-on="on">
        change</v-btn
      >
      <v-btn
        class="mb-2"
        v-else
        :disabled="!enabled"
        :loading="scheduling"
        outlined
        v-on="on"
        color="primary"
      >
        {{ $t("feed.ScheduleDialog.schedule") }}
        <v-icon right>mdi-av-timer</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="primary white--text">{{
        $t("feed.ScheduleDialog.schedulePost")
      }}</v-card-title>
      <v-card-text>
        <v-row justify="space-around" class="mt-2">
          <v-date-picker v-model="scheduledDate"></v-date-picker>
          <v-time-picker :allowed-minutes="allowedMinutes" v-model="scheduledTime"></v-time-picker>
        </v-row>
        <p class="primary--text mt-2 title" align="right" v-show="date">
          {{ $t("feed.ScheduleDialog.postAt") }} {{ date | toDate("Pp") }}
        </p>
        <p v-if="feedback" align="right" class="error--text mt-2">
          {{ feedback }}
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="scheduleDialog = false">{{
          $t("common.cancel")
        }}</v-btn>
        <v-btn class="primary" @click="schedulePost">{{
          editingDate != undefined ? $t("common.update") : $t("feed.ScheduleDialog.schedule")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { format, parseISO } from "date-fns";

export default {
  props: ["editingDate", "scheduling", "enabled"],
  data: () => ({
    scheduledDate: format(new Date(), "yyyy-MM-dd"),
    scheduledTime: null,
    scheduleDialog: false,
    feedback: null,
  }),
  computed: {
    date() {
      if (!this.scheduledTime || !this.scheduledDate) return null;
      return parseISO(`${this.scheduledDate} ${this.scheduledTime}`);
    },
  },
  watch: {
    editingDate(date) {
      this.scheduledDate = format(date, "yyyy-MM-dd");
      this.scheduledTime = format(date, "HH:mm");
    },
  },
  mounted() {
    if (this.$props.editingDate) {
      this.scheduledDate = format(this.editingDate, "yyyy-MM-dd");
      this.scheduledTime = format(this.editingDate, "HH:mm");
    }
  },
  methods: {
    allowedMinutes: (m) => m % 15 === 0,
    schedulePost() {
      if (!this.date) {
        this.feedback = this.$t("feed.ScheduleDialog.dateHint");
        return;
      }
      this.feedback = null;
      this.$emit("post", this.date);
      this.scheduleDialog = false;
    },
  },
};
</script>
